import { render, staticRenderFns } from "./DatabaseTotalsCards.vue?vue&type=template&id=2ae460c0&scoped=true"
import script from "./DatabaseTotalsCards.vue?vue&type=script&lang=js"
export * from "./DatabaseTotalsCards.vue?vue&type=script&lang=js"
import style0 from "./DatabaseTotalsCards.vue?vue&type=style&index=0&id=2ae460c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae460c0",
  null
  
)

export default component.exports